"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
require("core-js/modules/es.object.get-prototype-of.js");
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterRows = exports.ConfigRow = void 0;
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.array.concat.js");
var _react = _interopRequireDefault(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _FemaGoTable = _interopRequireDefault(require("../../go/components/common/tables/femaGoTable/FemaGoTable"));
var _utils = require("../../common/utils");
var _contentDispatch = require("../../framework/components/contentDispatch");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var filterRows = function filterRows(data, filters) {
  if (_lodash.default.isEmpty(filters)) {
    return data;
  }
  return _lodash.default.filter(data, function (item) {
    var passes = true;
    _lodash.default.forEach(filters, function (rule) {
      passes = passes && (0, _utils.evaluateOperator)(rule.operator, _lodash.default.get(item, rule.filterBy), rule.value);
    });
    return passes;
  });
};
exports.filterRows = filterRows;
var ConfigRow = /*#__PURE__*/function (_React$Component) {
  _inherits(ConfigRow, _React$Component);
  var _super = _createSuper(ConfigRow);
  function ConfigRow() {
    _classCallCheck(this, ConfigRow);
    return _super.apply(this, arguments);
  }
  _createClass(ConfigRow, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        data = _this$props.data,
        rows = _this$props.rows,
        fixedRow = _this$props.fixedRow,
        contentRow = _this$props.contentRow,
        isDataSanitized = _this$props.isDataSanitized,
        filterRules = _this$props.filterRules,
        isHidden = _this$props.isHidden,
        contentRows = _this$props.contentRows,
        contentRowsNumber = _this$props.contentRowsNumber,
        rootPath = _this$props.rootPath,
        tableHeaders = _this$props.tableHeaders,
        labelWithFirstCell = _this$props.labelWithFirstCell,
        contentMap = _this$props.contentMap,
        _this$props$rowSpan = _this$props.rowSpan,
        rowSpan = _this$props$rowSpan === void 0 ? [1] : _this$props$rowSpan;

      // A row template that renders for each piece of data
      var renderRows = rows && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _lodash.default.map(filterRows(data, filterRules), function (row, index) {
        return /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.Row, {
          key: index
        }, _lodash.default.map(rows, function (column, index2) {
          return /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.TextCell, {
            key: index2,
            rowSpan: rowSpan[index2] || 1
          }, (0, _utils.compileContent)(column, {
            data: row
          }, isDataSanitized));
        }));
      }));
      //24 rows
      var renderContentRows = contentRows && contentRowsNumber > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _lodash.default.map(new Array(Number(contentRowsNumber)), function (row, rowIndex) {
        return /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.Row, {
          key: rowIndex
        }, _lodash.default.map(contentRows, function (conf, index2) {
          return /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.TextCell, {
            key: index2,
            rowSpan: rowSpan[index2] || 1
          }, /*#__PURE__*/_react.default.createElement(_contentDispatch.ContentDispatch, {
            contentMap: contentMap,
            key: conf.id || rowIndex,
            config: conf,
            rowIndex: rowIndex,
            isHidden: isHidden,
            rootPath: rootPath
          }));
        }));
      }));

      // A single defined row
      var renderRow = fixedRow && /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.Row, null, _lodash.default.map(fixedRow, function (column, index) {
        return /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.TextCell, {
          key: index,
          rowSpan: rowSpan[index] || 1
        }, (0, _utils.compileContent)(column, {
          data: data
        }, isDataSanitized));
      }));

      // A single defined row
      var renderContentRow = contentRow && /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.Row, null, _lodash.default.map(contentRow, function (conf, index) {
        return /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.TextCell, {
          key: index,
          rowSpan: rowSpan[index] || 1
        }, /*#__PURE__*/_react.default.createElement(_contentDispatch.ContentDispatch, {
          contentMap: contentMap,
          key: conf.id || index,
          config: conf,
          isHidden: isHidden,
          rootPath: rootPath,
          ariaLabelledBy: labelWithFirstCell ? "".concat(contentRow[0].id, " ").concat(!_lodash.default.isUndefined(tableHeaders) && !_lodash.default.isUndefined(tableHeaders[index]) ? tableHeaders[index] : '', "  ").concat(conf.id ? conf.id : '') // includes the value entered in the field in the aria text
          : undefined
        }));
      }));
      return renderRows || renderRow || renderContentRow || renderContentRows;
    }
  }]);
  return ConfigRow;
}(_react.default.Component);
exports.ConfigRow = ConfigRow;